import { scalingPx } from 'util/css';
import { Box, BoxProps } from '@mui/material';
import { Divider } from 'components/ui';
import React, { ReactElement, ReactNode } from 'react';

export interface MainLayoutTopProps extends BoxProps {
  children: ReactNode;
}

export const Top = ({
  children,
  ...boxProps
}: MainLayoutTopProps): ReactElement => {
  const leftPadding = scalingPx(24, 86);
  const topPadding = scalingPx(24, 40);

  return (
    <Box>
      <Box pt={topPadding} pl={leftPadding} {...boxProps}>
        {children}
      </Box>
      <Divider size={10} withBorder />
    </Box>
  );
};
